<div class="fees-page">
  <section class="hero">
    <div class="hero__bg-grid"></div>
    <div class="hero__orb hero__orb--1"></div>
    <div class="hero__orb hero__orb--2"></div>
    <div class="container">
      <div class="hero__badge">
        <span class="badge-dot"></span>
        Transparent Pricing
      </div>
      <h1 class="hero__title">
        Simple,<br />
        <span class="hero__title--accent">Competitive</span> Fees
      </h1>
      <p class="hero__subtitle">
        No hidden charges. No surprises. Trade futures, options with confidence.
      </p>
      <div class="hero__stats">
        <div class="stat-card" *ngFor="let stat of heroStats">
          <span class="stat-card__value">{{ stat.value }}</span>
          <span class="stat-card__label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="tab-section">
    <div class="container">
      <div class="tab-bar gap-4">
        <button
          class="tab-bar__btn"
          *ngFor="let tab of mainTabs"
          [class.tab-bar__btn--active]="activeMainTab === tab.id"
          (click)="setMainTab(tab.id)"
        >
          <i [class]="tab.icon + ' tab-bar__icon'"></i>
          <span class="tab-bar__label">{{ tab.label }}</span>
        </button>
      </div>
    </div>
  </section>

  <section class="content-section" *ngIf="activeMainTab === 'trading'">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Trading Fees</h2>
        <p class="section-sub">
          Maker / Taker model — earn rebates by adding liquidity
        </p>
      </div>

      <div class="fee-grid">
        <!-- Futures -->
        <div class="fee-card fee-card--futures">
          <div class="fee-card__header">
            <i class="pi pi-bolt fee-card__icon"></i>
            <div>
              <h3 class="fee-card__title">Futures</h3>
              <p class="fee-card__desc">Perpetual & Expiry contracts</p>
            </div>
          </div>
          <div class="fee-row-group">
            <div class="fee-row">
              <span class="fee-row__label">Maker Fee</span>
              <span class="fee-row__val fee-row__val--maker">0.01%</span>
            </div>
            <div class="fee-row">
              <span class="fee-row__label">Taker Fee</span>
              <span class="fee-row__val fee-row__val--taker">0.01%</span>
            </div>
          </div>
        </div>

        <!-- Options -->
        <div class="fee-card fee-card--options">
          <div class="fee-card__header">
            <i class="pi pi-chart-bar fee-card__icon"></i>
            <div>
              <h3 class="fee-card__title">Options</h3>
              <p class="fee-card__desc">Capped at 1.75% of premium</p>
            </div>
          </div>
          <div class="fee-row-group">
            <div class="fee-row">
              <span class="fee-row__label">Maker Fee</span>
              <span class="fee-row__val fee-row__val--maker">0.01%</span>
            </div>
            <div class="fee-row">
              <span class="fee-row__label">Taker Fee</span>
              <span class="fee-row__val fee-row__val--taker">0.01%</span>
            </div>
          </div>
        </div>

        <!-- Spot -->
        <!-- <div class="fee-card fee-card--spot">
          <div class="fee-card__header">
            <i class="pi pi-sync fee-card__icon"></i>
            <div>
              <h3 class="fee-card__title">Spot</h3>
              <p class="fee-card__desc">Buy free, sell at low cost</p>
            </div>
          </div>
          <div class="fee-row-group">
            <div class="fee-row">
              <span class="fee-row__label">Buy Order</span>
              <span class="fee-row__val fee-row__val--maker">0%</span>
            </div>
            <div class="fee-row">
              <span class="fee-row__label">Sell Order</span>
              <span class="fee-row__val fee-row__val--taker">0.1%</span>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Notes -->
      <div class="notes-box">
        <div class="notes-box__title">
          <i class="pi pi-info-circle"></i> Important Notes
        </div>
        <ul class="notes-list">
          <li>18% GST is applicable on all trading fees</li>
          <li>
            Option fee is capped at <strong>1.75%</strong> of Option Premium
          </li>
          <li>Fees are applied on Notional / Order Value</li>
          <li>
            Settlement fee applies to all open contracts at time of settlement
            (Taker Fees)
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section class="content-section" *ngIf="activeMainTab === 'calculator'">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Fee Calculator</h2>
        <p class="section-sub">Estimate your trading costs before you trade</p>
      </div>

      <div class="calc-wrapper">
        <div class="calc-inputs">
          <div class="input-group">
            <label class="input-label">Instrument</label>
            <div class="toggle-group toggle-group--full">
              <button
                class="toggle-btn"
                [class.toggle-btn--active]="calcType === 'futures'"
                (click)="calcType = 'futures'; recalculate()"
              >
                Futures
              </button>
              <button
                class="toggle-btn"
                [class.toggle-btn--active]="calcType === 'options'"
                (click)="calcType = 'options'; recalculate()"
              >
                Options
              </button>
            </div>
          </div>

          <div class="input-group" *ngIf="calcType == 'futures'">
            <label class="input-label">Contract</label>
            <div class="select-wrapper">
              <select
                class="styled-select"
                [(ngModel)]="selectedContract"
                (change)="onContractChange()"
              >
                <option *ngFor="let c of contracts" [value]="c.symbol">
                  {{ c.symbol }}
                </option>
              </select>
              <span class="select-arrow">▾</span>
            </div>
            <!-- <span class="input-hint"
              >1 lot = {{ selectedContractObj?.lotSize }}
              {{ selectedContractObj?.asset }}</span
            > -->
          </div>

          <div class="input-group" *ngIf="calcType == 'options'">
            <label class="input-label">Contract</label>
            <div class="toggle-group toggle-group--full">
              <button
                class="toggle-btn"
                [class.toggle-btn--active]="selectedContract === 'BTCUSDT'"
                (click)="selectedContract = 'BTCUSDT'; recalculate()"
              >
                BTC
              </button>
              <button
                class="toggle-btn"
                [class.toggle-btn--active]="selectedContract === 'ETHUSDT'"
                (click)="selectedContract = 'ETHUSDT'; recalculate()"
              >
                ETH
              </button>
            </div>
          </div>

          <div class="input-group">
            <label class="input-label">Entry Price</label>
            <input
              class="styled-input"
              type="number"
              [(ngModel)]="entryPrice"
              (ngModelChange)="recalculate()"
              placeholder="0.00"
            />
            <div
              class="maker-taker-toggle maker-taker-toggle--full"
              *ngIf="calcType == 'futures'"
            >
              <button
                class="mt-btn"
                [class.mt-btn--active]="entryType === 'maker'"
                (click)="entryType = 'maker'; recalculate()"
              >
                Maker
              </button>
              <button
                class="mt-btn"
                [class.mt-btn--active]="entryType === 'taker'"
                (click)="entryType = 'taker'; recalculate()"
              >
                Taker
              </button>
            </div>
          </div>

          <div class="input-group">
            <label class="input-label">Exit Price</label>
            <input
              class="styled-input"
              type="number"
              [(ngModel)]="exitPrice"
              (ngModelChange)="recalculate()"
              placeholder="0.00"
            />
            <div
              class="maker-taker-toggle maker-taker-toggle--full"
              *ngIf="calcType == 'futures'"
            >
              <button
                class="mt-btn"
                [class.mt-btn--active]="exitType === 'maker'"
                (click)="exitType = 'maker'; recalculate()"
              >
                Maker
              </button>
              <button
                class="mt-btn"
                [class.mt-btn--active]="exitType === 'taker'"
                (click)="exitType = 'taker'; recalculate()"
              >
                Taker
              </button>
            </div>
          </div>

          <div class="input-group">
            <label class="input-label">Quantity (Lots)</label>
            <input
              class="styled-input"
              type="number"
              [(ngModel)]="quantity"
              (ngModelChange)="recalculate()"
              placeholder="1"
              min="1"
            />
          </div>

          <!-- <div class="input-group">
            <label class="input-label">Scalper Offer</label>
            <div class="toggle-group toggle-group--full">
              <button
                class="toggle-btn"
                [class.toggle-btn--active]="!scalperActive"
                (click)="scalperActive = false; recalculate()"
              >
                Inactive
              </button>
              <button
                class="toggle-btn toggle-btn--orange"
                [class.toggle-btn--active]="scalperActive"
                (click)="scalperActive = true; recalculate()"
              >
                Active
              </button>
            </div>
          </div> -->
        </div>

        <div class="calc-results">
          <div class="result-header">
            <span class="result-header__label">Calculation Summary</span>
            <span class="result-header__contract">{{
              selectedContractObj?.name
            }}</span>
          </div>

          <div class="result-row">
            <span class="result-row__label">Notional / Value</span>
            <span class="result-row__val"
              >${{ notional | number: "1.2-2" }}</span
            >
          </div>

          <div class="result-divider"></div>

          <!-- <div class="result-row">
            <span class="result-row__label">Entry Fee ({{ entryType }})</span>
            <span class="result-row__val"
              >₹{{ entryFee | number: "1.2-2" }}</span
            >
          </div> -->
          <!-- 
          <div class="result-row">
            <span class="result-row__label">Exit Fee ({{ exitType }})</span>
            <span class="result-row__val"
              >₹{{ result.exitFee | number: "1.2-2" }}</span
            >
          </div> -->

          <div class="result-row result-row--total mt-3">
            <span class="result-row__label">Trading Fees</span>
            <span class="result-row__val result-row__val--highlight"
              >${{ totalFees | number: "1.2-2" }}</span
            >
          </div>

          <div class="result-row result-row--gst mt-3">
            <span class="result-row__label">Total Fees (inc. 18% GST)</span>
            <span class="result-row__val result-row__val--orange"
              >${{ totalWithGST | number: "1.2-2" }}</span
            >
          </div>

          <div class="result-divider my-3"></div>

          <!-- <div class="result-row">
            <span class="result-row__label">Points to Breakeven</span>
            <span class="result-row__val">{{
              result.breakeven | number: "1.2-2"
            }}</span>
          </div> -->

          <div
            class="result-row result-pnl"
            [class.result-pnl--positive]="pnl >= 0"
            [class.result-pnl--negative]="pnl < 0"
          >
            <span class="result-row__label">Net P&L</span>
            <span class="result-row__val result-row__val--pnl">
              {{ pnl >= 0 ? "+" : "" }}${{ pnl | number: "1.2-2" }}
            </span>
          </div>

          <div class="calc-cta">
            <button class="btn-primary" (click)="resetCalculator()">
              Reset Calculator
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="content-section" *ngIf="activeMainTab === 'deposit'">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Deposit & Withdrawal Fees</h2>
        <p class="section-sub">Move your funds securely with minimal costs</p>
      </div>

      <div class="dw-grid">
        <div class="dw-card" *ngFor="let item of depositFees">
          <div class="dw-card__top">
            <div class="dw-card__icon">
              <i [class]="item.icon + ' dw-icon'"></i>
            </div>
            <div class="dw-card__name">{{ item.name }}</div>
          </div>
          <div class="dw-card__row">
            <span class="dw-label">Deposit</span>
            <span class="dw-val dw-val--free">{{ item.deposit }}</span>
          </div>
          <div class="dw-card__row">
            <span class="dw-label">Withdrawal</span>
            <span class="dw-val">{{ item.withdrawal }}</span>
          </div>
          <div class="dw-card__row" *ngIf="item.minWithdrawal">
            <span class="dw-label">Min Withdrawal</span>
            <span class="dw-val">{{ item.minWithdrawal }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="content-section" *ngIf="activeMainTab === 'liquidation'">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Liquidation Fees</h2>
        <p class="section-sub">Understand the cost of liquidation events</p>
      </div>

      <div class="liq-table-wrapper">
        <div class="liq-mobile-cards">
          <div class="liq-mobile-card" *ngFor="let row of liquidationFees">
            <div class="liq-mobile-card__header">
              <span class="liq-badge">{{ row.type }}</span>
              <span class="liq-fee">{{ row.fee }}</span>
            </div>
            <div class="liq-mobile-card__row">
              <span class="liq-mobile-label">Insurance Fund</span>
              <span class="liq-mobile-val">{{ row.insurance }}</span>
            </div>
            <p class="liq-mobile-desc">{{ row.description }}</p>
          </div>
        </div>
        <table class="liq-table">
          <thead>
            <tr>
              <th>Margin Type</th>
              <th>Liquidation Fee</th>
              <th>Insurance Fund</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of liquidationFees">
              <td>
                <span class="liq-badge">{{ row.type }}</span>
              </td>
              <td class="liq-fee">{{ row.fee }}</td>
              <td>{{ row.insurance }}</td>
              <td class="liq-desc">{{ row.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <section class="footer-cta">
    <div class="container">
      <h2 class="footer-cta__title">Ready to Start Trading?</h2>
      <p class="footer-cta__sub">
        Open your account in minutes. Zero deposit fees. Start with as low as
        $10.
      </p>
      <div class="footer-cta__actions">
        <button
          class="btn-primary btn-primary--lg"
          (click)="onNavigate('/user/signup')"
        >
          Create Account
        </button>
        <button class="btn-ghost" (click)="onNavigate('/trading/market')">
          View Markets
        </button>
      </div>
    </div>
  </section>
</div>
